<script setup lang="ts">
const { trackEvent } = useGAnalytics();
const emit = defineEmits(["close", "force-logout"]);
const route = useRoute();
const userStore = useUserStore();
const countdownEnd = ref();
const { idleModalTimeout } = useRuntimeConfig().public;
const localePath = useLocalePath();
const isFocused = useWindowFocus();
const key = ref(0);

const forceLogout = () => {
  trackEvent("user_forced_log_out");
  userStore.logOut();
  if (route.path.includes("user-portal"))
    navigateTo(localePath(`/?redirect=${route.path}`));
  emit("force-logout");
};

const doLogout = () => {
  userStore.logOut();
  if (route.path.includes("user-portal")) navigateTo(localePath("/"));
  emit("close");
};

const getUtcTime = () => {
  key.value++;
  const currentTime = new Date();
  currentTime.setTime(currentTime.getTime() + idleModalTimeout * 60 * 1000);
  countdownEnd.value = currentTime.toUTCString();
};

onMounted(() => {
  trackEvent("user_idle");
  getUtcTime();
});

watch(isFocused, (focused) => {
  if (focused) {
    if (userStore.isExpired) forceLogout();
    else getUtcTime();
  }
});
</script>
<template>
  <BaseLayoutModal width="medium" @close="$emit('close')">
    <template #header>
      {{ $t("main.modalIdleUser.automaticSignOut") }}
    </template>
    <template #content>
      <p class="text-neutral-200 font-bold">
        {{ $t("main.modalIdleUser.sessionAboutToExpire") }}
      </p>
      <p class="text-neutral-300">
        {{ $t("main.modalIdleUser.securityTimeout") }}
      </p>
      <p class="text-neutral-300">
        {{ $t("main.modalIdleUser.extendSessionInstruction") }}
      </p>
      <div class="mt-4">
        <p class="text-primary-500 font-bold">
          {{ $t("main.modalIdleUser.sessionSignOutIn") }}
        </p>
        <CommonCountdown
          :key="key"
          class="text-neutral-200 font-bold"
          :datetime="countdownEnd"
          time-style="secondsOnly"
          @countdown-ended="forceLogout" />
      </div>
      <div class="mt-5 mb-2 sm:mt-6 flex">
        <div class="flex items-center gap-4">
          <BaseButtonSubmit
            :text="$t('main.modalIdleUser.extendSessionButton')"
            data-test="button-extend-session"
            @click="$emit('close')" />
          <BaseButtonCancel
            type="button"
            :text="$t('main.modalIdleUser.signOutButton')"
            data-test="button-sign-out-from-idle-expired"
            @click="doLogout" />
        </div>
      </div>
    </template>
  </BaseLayoutModal>
</template>
